module.exports = __webpack_public_path__ + "static/img/1.41a1873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/4/1.png
// module id = QOIf
// module chunks = 0